export default __webpack_public_path__ + "static/media/bt.eed19cbf.svg";